import { getSonarObjectTypeSourceLabel } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { PeriscopeLink, PeriscopeSource } from '@ui/icons';

export interface PeriscopeSourceLabelProps {
	sonarObjectType: SonarObjectType;
	url?: string;
}

export const PeriscopeSourceLabel: React.FC<PeriscopeSourceLabelProps> = ({ sonarObjectType, url }) => {
	const sourceLabel = getSonarObjectTypeSourceLabel(sonarObjectType);

	return (
		<div className='source-label'>
			<PeriscopeSource
				iconColor='rgba(255, 255, 255, 0.85)'
				sonarObjectType={ sonarObjectType } />
			{ sourceLabel }
			<PeriscopeLink
				iconColor='rgba(255, 255, 255, 0.85)'
				sonarObjectType={ sonarObjectType }
				url={ url } />
		</div>
	);
};
